var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-text-field', _vm._b({
    attrs: {
      "flat": "",
      "solo": "",
      "hide-details": ""
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.sendMessage.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-btn', _vm._b({
          staticClass: "mr-n8",
          attrs: {
            "small": "",
            "text": "",
            "icon": ""
          },
          on: {
            "click": _vm.sendMessage
          }
        }, 'v-btn', {
          loading: _vm.loading
        }, false), [_c('v-icon', [_vm._v("mdi-send")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.message,
      callback: function ($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }, 'v-text-field', {
    loading: _vm.loading
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }